/** Categoría Academy para el manual único de subida de programas. */
export const WIKI_SUBIDA_PROGRAMAS_CATEGORY = 'wiki-subida-programas-tno';

export const WIKI_SUBIDA_PROGRAMAS_HERO_SLUG = 'wiki-subprog-hero';

/** Cuerpo único del manual (HTML largo en una sola knowledge page). */
export const WIKI_SUBIDA_PROGRAMAS_BODY_SLUG = 'wiki-subprog-manual-completo';
